import { CommandProps, Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { BlockTypes, StoryCardBlockData } from '../../../../models';
import { StoryCardNodeView } from './StoryCardNodeView';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    storyCardNode: { insertStoryCardNode: ({ storyCard }: StoryCardBlockData) => ReturnType };
  }
}

export const StoryCardNode = Node.create({
  name: 'storyCardNode',
  group: 'block',
  atom: true,

  addAttributes() {
    return { storyCard: null };
  },

  parseHTML() {
    return [{ tag: BlockTypes.card }];
  },

  renderHTML({ HTMLAttributes }) {
    return [BlockTypes.card, mergeAttributes(HTMLAttributes)];
  },

  addCommands() {
    return {
      insertStoryCardNode:
        ({ storyCard }: StoryCardBlockData) =>
        ({ commands }: CommandProps) => {
          return commands.insertContent({ type: this.name, attrs: { storyCard } });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(StoryCardNodeView);
  },
});
